import { Box, Typography } from '@mui/material';
import React from 'react';

interface RegistrationFormBoxProps {
  children: React.ReactNode;
  text: string;
  icon: React.ReactNode;
}

const RegistrationFormBox: React.FC<RegistrationFormBoxProps> = ({ children, text, icon }) => {
  return(
    <Box sx={{
      height: '100%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'start',
      gap: '3.5%',
      alignItems: 'center',
      padding: '20px',
    }}>
      <Box sx={{
        minHeight: '56px',
        minWidth: '56px',
        backgroundColor: '#FFD8E9',
        borderRadius: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        {icon}
      </Box>
      <Typography variant={'h6'} fontWeight={'lighter'}>{text}</Typography>
      {children}
    </Box>
  )
}

export default RegistrationFormBox;